<div> 
    <!-- Common Header starts -->
    <header class="site-header clearfix">
        <a href="javascript:void(0)" class="login-header pull-left">
            <!-- <div class="login-header align-center"> -->
        <span class="login-logo"></span>
    <!-- </div> -->
        </a>
        <div class="site-search pull-right">
            <a (click)="gotoHome()" class="help-link">Home</a>
            <a (click)="logout()" class="help-link">Logout</a>
        </div>
    </header>
    <!-- Common Header Ends --> 
     <div class="mainContent">
        <router-outlet></router-outlet>
    </div>
    <footer class="footer"></footer>
</div>